var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6559 44.615C54.9275 44.615 58.402 41.14 58.402 36.8689V13.4185C58.402 9.14712 54.9275 5.67163 50.6559 5.67163H7.74488C3.47426 5.67163 0 9.14712 0 13.4185V36.8689C0 41.14 3.47426 44.615 7.74488 44.615H13.3816V52.7232C13.3816 53.7093 13.9754 54.5978 14.8861 54.9751C15.1879 55.0997 15.5045 55.1602 15.8181 55.1602C16.4523 55.1602 17.0759 54.9127 17.5421 54.4464L27.3716 44.615H50.6559Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2198 25.9514H62.3009V36.8689C62.3009 43.2902 57.0771 48.514 50.6558 48.514H28.9867L24.4304 53.0715C24.9795 56.2636 27.7651 58.7006 31.1113 58.7006H49.9787L57.891 66.6141C58.357 67.0803 58.9808 67.3281 59.6149 67.3281C59.9286 67.3281 60.2451 67.2669 60.547 67.1423C61.4576 66.765 62.0512 65.8767 62.0512 64.8908V58.7003H66.2201C69.9588 58.7003 73.0002 55.6579 73.0002 51.9187V32.732C73 28.9933 69.9586 25.9514 66.2198 25.9514Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0d60291c72c530e3e5e987d8989c55ae.svg";
export { ForwardRef as ReactComponent };